"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const js_client_sdk_common_1 = require("@eppo/js-client-sdk-common");
const util_1 = require("../util");
/** A localStorage-backed NamedEventQueue. */
class LocalStorageBackedNamedEventQueue {
    constructor(name) {
        this.name = name;
        this.eventKeys = [];
        this.localStorageKey = `eventQueue:${this.name}`;
        this.loadStateFromLocalStorage();
    }
    splice(count) {
        const arr = Array.from({ length: count }, () => this.shift());
        return (0, util_1.takeWhile)(arr, (item) => item !== undefined);
    }
    isEmpty() {
        return this.length === 0;
    }
    get length() {
        return this.eventKeys.length;
    }
    push(event) {
        const eventKey = this.generateEventKey(event);
        const serializedEvent = JSON.stringify(event);
        localStorage.setItem(eventKey, serializedEvent);
        this.eventKeys.push(eventKey);
        this.saveStateToLocalStorage();
    }
    *[Symbol.iterator]() {
        for (const key of this.eventKeys) {
            const eventData = localStorage.getItem(key);
            if (eventData) {
                yield JSON.parse(eventData);
            }
        }
    }
    shift() {
        if (this.eventKeys.length === 0) {
            return undefined;
        }
        const eventKey = this.eventKeys.shift();
        if (!eventKey) {
            throw new Error('Unexpected undefined event key');
        }
        const eventData = localStorage.getItem(eventKey);
        if (eventData) {
            localStorage.removeItem(eventKey);
            this.saveStateToLocalStorage();
            return JSON.parse(eventData);
        }
        return undefined;
    }
    loadStateFromLocalStorage() {
        const serializedState = localStorage.getItem(this.localStorageKey);
        if (serializedState) {
            try {
                this.eventKeys = JSON.parse(serializedState);
            }
            catch (_a) {
                js_client_sdk_common_1.applicationLogger.error(`Failed to parse event queue ${this.name} state. Initializing empty queue.`);
                this.eventKeys = [];
            }
        }
    }
    saveStateToLocalStorage() {
        const serializedState = JSON.stringify(this.eventKeys);
        localStorage.setItem(this.localStorageKey, serializedState);
    }
    generateEventKey(event) {
        const hash = this.hashEvent(event);
        return `eventQueue:${this.name}:${hash}`;
    }
    hashEvent(event) {
        const serializedEvent = JSON.stringify(event);
        let hash = 0;
        for (let i = 0; i < serializedEvent.length; i++) {
            hash = (hash << 5) - hash + serializedEvent.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return hash.toString(36);
    }
}
exports.default = LocalStorageBackedNamedEventQueue;
//# sourceMappingURL=local-storage-backed-named-event-queue.js.map